export default __webpack_public_path__ + "static/videoIntroThumb-bc57d99ee9a3694cd62aeefc40ed2b23.png";